import checkIcon from 'assets/images/check.svg';
import { AlertStyled, IconWrapper } from 'components/alert/alert.styles';
import { lighten, rem, size } from 'polished';
import styled from 'styled-components';

export const PlanStatusCardStyled = styled(AlertStyled)`
  position: relative;
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.palette.white};

  * {
    color: ${({ theme }) => theme.colors.palette.black};
  }

  &:hover {
    background-color: ${({ theme }) =>
      lighten(0.45, theme.colors.palette.grey)};
  }

  &::after {
    ${size(rem(20))};

    position: absolute;
    top: ${rem(14)};
    right: ${rem(14)};
    background-image: url(${checkIcon});
    background-size: cover;
    content: '';
  }

  strong {
    display: block;
    margin: 0;
  }

  ${IconWrapper} {
    padding: 0;

    svg {
      fill: none;
      ${size(rem(32))};
    }
  }
`;
